import { createContext } from 'react';
import { PolicyObjectTypeOptions } from "../_types/ewpolicy";
import { IUser, IUserState } from '../_types/user';



const nullUser: IUser = { authorized: false, fromCookie: true, objectType: PolicyObjectTypeOptions.user };

const defaultUserState: IUserState = {
    user: nullUser,
    setUser: (): void => {},
  };

export const AuthContext = createContext<IUserState>(defaultUserState);